import Project1 from "../assets/project-writer.png";
import Project2 from "../assets/project-linktree.png";
import Project3 from "../assets/project-ibice.png";

import Project4 from "../assets/project-cv.png";
import Project5 from "../assets/project-courses.png";
import Project6 from "../assets/project-tuwiki.png";

const ProjectsCardData = [
    {
        imgsrc: Project1,
        title: "Portfolio literario para profesionales",
        text: "HTML | CSS | JS | Vercel | & More",
        view: "https://arturourbanos-portfolio.vercel.app/",
        source: "https://github.com/ArturoCode/writer-portfolio"
    },
    {
        imgsrc: Project2,
        title: "Linktree personalizado para creadores",
        text: "HTML | CSS | Bootstrap | & More",
        view: "https://arturocode.github.io/links/",
        source: "https://github.com/ArturoCode/links"
    },
    {
        imgsrc: Project3,
        title: "Excursiones Íbice (empresa ficticia)",
        text: "JS | Node.js | MySQL | Railway | & More",
        view: "https://excursiones-ibice.up.railway.app/",
        source: "https://github.com/ArturoCode/excursiones-ibice"
    },
    {
        imgsrc: Project4,
        title: "CV virtual para desarollador web",
        text: "HTML | CSS | JavaScript | & More",
        view: "https://arturocode.github.io/cv-virtual/",
        source: "https://github.com/ArturoCode/cv-virtual"
    },
    {
        imgsrc: Project5,
        title: "Galería web de cursos realizados",
        text: "HTML | CSS | & More",
        view: "https://arturocode.github.io/cursos/",
        source: "https://github.com/ArturoCode/cursos"
    },
    {
        imgsrc: Project6,
        title: "TuWiki | Página para tus proyectos",
        text: "Angular | MongoDB | Node.js | & More",
        view: "https://github.com/ArturoCode/tu-wiki",
        source: "https://github.com/ArturoCode/tu-wiki"
    },
]

export default ProjectsCardData